import { ApiClientError } from './ApiClientError';

/**
 * リソース無しエラー
 */
export class NotFoundError extends ApiClientError {
  override name = 'NotFoundError';
}
